import { getPath } from '@/router/common'
const baseUrl = {
  title: '财务准备',
  path: 'FinancialPreparation'
}

export default [
  {
    path: getPath('AccountDefinition', baseUrl),
    name: 'AccountDefinition',
    component: () => import(/* webpackChunkName: "AccountDefinition" */ '@/views/financialPreparation/accountDefinition/index.vue'),
    meta: {
      title: '科目定义'
    }
  },
  {
    path: getPath('WriteOffSubject', baseUrl),
    name: 'WriteOffSubject',
    component: () => import(/* webpackChunkName: "WriteOffSubject" */ '@/views/financialPreparation/writeOffSubject/index.vue'),
    meta: {
      title: '科目核销对应'
    }
  },
  {
    path: getPath('b_dj_content', baseUrl),
    name: 'b_dj_content',
    component: () => import(/* webpackChunkName: "b_dj_content" */ '@/views/financialPreparation/b_dj_content/index.vue'),
    meta: {
      title: '定义摘要'
    }
  },
  {
    path: getPath('Add_b_dj_content', baseUrl),
    name: 'Add_b_dj_content',
    component: () => import(/* webpackChunkName: "Add_b_dj_content" */ '@/views/financialPreparation/add_b_dj_content/index.vue'),
    meta: {
      title: '摘要定义'
    }
  },
  {
    path: getPath('B_ACCOUNT_CN_BILLTYPE', baseUrl),
    name: 'B_ACCOUNT_CN_BILLTYPE',
    component: () => import(/* webpackChunkName: "B_ACCOUNT_CN_BILLTYPE" */ '@/views/financialPreparation/b_ACCOUNT_CN_BILLTYPE/index.vue'),
    meta: {
      title: '去向及结算方式'
    }
  },
  {
    path: getPath('AccountingItems', baseUrl),
    name: 'AccountingItems',
    component: () => import(/* webpackChunkName: "AccountingItems" */ '@/views/financialPreparation/accountingItems/index.vue'),
    meta: {
      title: '核算项目'
    }
  },
  {
    path: getPath('Subordinateline', baseUrl),
    name: 'Subordinateline',
    component: () => import(/* webpackChunkName: "Subordinateline" */ '@/views/financialPreparation/subordinateline/index.vue'),
    meta: {
      title: '隶属线路信息'
    }
  }
]
